import React from 'react'
import './Typing.css'
const Typing = () => {
    return (
        <div className="typing">
            <div className="typing__dot"></div>
            <div className="typing__dot"></div>
            <div className="typing__dot"></div>
        </div>
    )
}

export default Typing